import { AnalyticsContext, ContextType } from '@carvana/eventable-clickstream';
import VehicleOffering from '@carvana/merch-contracts/VehicleOffering';
import { ReactNode, useContext } from 'react';
import DsModal from '@/common/DsModal';
import MediaContent from '@/common/helios/Modals/GeoModal/MediaContent';
import ModalContents from '@/common/helios/Modals/GeoModal/ModalContents';
import { useIsDesktop, useIsMobile } from '~/context/common/DeviceContext';
import LocationContextProvider, {
  LocationContext
} from '~/context/common/LocationContext';
import { useUserLocation } from '~/context/common/UserContext';
import useGeolocationConfig from '~/hooks/common/geolocation/useGeolocationConfig';

type OwnProps = {
  AvailabilityOptions?: ReactNode;
  isGeolocationModalOpen: boolean;
  offeringType?: VehicleOffering;
  onSuccessfulZipChange?: () => void;
  setGeolocationModalOpen: (open: boolean) => void;
  trackEvent?: ContextType['trackEvent'];
};

function GeoModal({
  AvailabilityOptions,
  isGeolocationModalOpen,
  setGeolocationModalOpen
}: OwnProps) {
  const { isDeliveryAllowed = false, pickUpInfoToDisplay = null } =
    useContext(LocationContext);
  const isDesktop = useIsDesktop();
  const isMobile = useIsMobile();

  const willHaveVideoContent =
    !isMobile &&
    (isDeliveryAllowed ||
      pickUpInfoToDisplay?.locationType === 'VendingMachine');

  const desktopModalWidth = willHaveVideoContent ? '1008px' : '504px';

  return (
    <DsModal
      mediaComponent={willHaveVideoContent ? <MediaContent /> : undefined}
      mobileStyle="inset"
      onClose={() => {
        setGeolocationModalOpen(false);
      }}
      isOpen={isGeolocationModalOpen}
      desktopWidth={isDesktop ? desktopModalWidth : '90vw'}
      classes={{
        body: isMobile ? 'py-2xl' : '',
        container: 'max-h-[95%]'
      }}
    >
      <ModalContents AvailabilityOptions={AvailabilityOptions} />
    </DsModal>
  );
}

export default function GeolocationModalWrapper(props: OwnProps) {
  const {
    isGeolocationModalOpen,
    offeringType,
    onSuccessfulZipChange,
    setGeolocationModalOpen,
    trackEvent: customTrackEvent
  } = props;
  const { trackEvent: analyticsTrackEvent } = useContext(AnalyticsContext);
  const { zip } = useUserLocation();
  const config = useGeolocationConfig({
    offeringType,
    onSuccessfulZipChange,
    setGeolocationModalOpen
  });

  return (
    <LocationContextProvider
      currentZip={zip}
      isOpen={isGeolocationModalOpen}
      trackEvent={customTrackEvent ?? analyticsTrackEvent}
      {...config}
    >
      <GeoModal {...props} />
    </LocationContextProvider>
  );
}
